export default "__VITE_ASSET__BSWOZ3fg__"